export default {
    title: 'تعرف على شريك حياتك',
    safeHands: 'انت بين ايادي امينة',
    safeHandsText: `موقع شريك عمري يتمتع بتقنيه عالية الجودة من حيث الصور وعمليه البحث وطرق التواصل مع الاعضاء وكما ان الموقع يقدم الكثير من الخدمات للباحثين عن شريك العمر.
<br><br>
    موقع شريك عمري هو زواج وتعارف ليس له اي علاقة باي موقع اخر لا من قريب ولا من بعيد اطلاقا نحن موقع يتمتع باستقلالية تامة ونعمل على مدار الساعة حتى نؤمن خدمة التواصل والتعارف والزواج بين اعضاء الموقع.
    <br><br>
    يشرفنا وجودكم و ننصحكم بالتسجيل في الموقع كي تكونو احد الاعضاء.
    <br><br>
    اطيب التمنيات بالتوفيق<br>
    ادارة شريك عمري`,
    getApp: 'حمل التطبيق',
    getAppText: 'يمكنك تحميل تطبيق شريك عمري من متجر غوغل او من ابل ستور',
    aboutUs: 'من نحن',
    aboutUsText:
        'موقع شريك عمري موقع مستقل تماما ونحن نعمل على مداؤ الساعة لتقديم افضل الخدمات لمشاركينا ويسعدنا ان تكون احد اعضاء الموقع بالضغط على التسجيل وملاء البيانات المطلوبة واهلا وسهلا بكم.',
    contactUs: 'مراسلة الادارة',
    contactUsButton: ' أرسل لنا رسالة',
    online: 'متواجد الان'
}
